<div class="flex flex-col filter-modal-container relative">
  <lla-overview-filters-list
    [tableActions]="data.tableActions"
    [tableFilters]="data.tableFilters"
    [filters]="data.filters"
    [advancedFilterKey]="data.advancedFilterKey"
    (filterChanged)="
      dialogRef.close({
        type: 'filterChanged',
        event: $event
      })
    "
    (clearAllFilters)="
      dialogRef.close({
        type: 'clearAllFilters'
      })
    "
  ></lla-overview-filters-list>

  <!-- Footer -->
  <div class="mx-base py-sm">
    <lla-button variant="secondary" size="medium" type="button" (click)="dialogRef.close()">
      Cancel
    </lla-button>
  </div>
</div>
